import { UseMutationOptions, useMutation } from 'react-query';
import { mutateMarketsStatus } from './marketStatus';
import { TMarketsStatus } from './marketStatus.types';

export const useMutationMarketsStatus = (
  options?: UseMutationOptions<unknown, unknown, TMarketsStatus>
) => useMutation((data) => mutateMarketsStatus(data), options);
